import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCopyright: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="copyright"><path d="M20.75 11.75C20.75 16.7206 16.7206 20.75 11.75 20.75C6.77944 20.75 2.75 16.7206 2.75 11.75C2.75 6.77944 6.77944 2.75 11.75 2.75C16.7206 2.75 20.75 6.77944 20.75 11.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15.2149 9.75C14.5233 8.5544 13.2306 7.75 11.75 7.75C9.54086 7.75 7.75 9.54086 7.75 11.75C7.75 13.9591 9.54086 15.75 11.75 15.75C13.2306 15.75 14.5233 14.9456 15.2149 13.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCopyright;
